import {
    EmailDataFormParameters,
    SsoParameters,
    SsoLandingPageParameters,
    SsoSuccessDataResponse,
} from 'store/auth/actions/auth-actions/auth-action-types';
import { authAPI } from 'API/auth-api';
import { goToHref } from 'router/go-to';
import type { PlacerResponseData } from '@placer-ui/types';

export const authSendSsoEmail = async (userData: EmailDataFormParameters, next_url: string | null) => {
    const ssoParameter: SsoParameters = {
        email: userData.email,
        next_url: `${next_url ?? ''}`,
    };

    try {
        const response: Response = await authAPI.sendSsoEmail(ssoParameter);

        if (response.ok) {
            ssoRedirect(response);
        }

        return response.status;
    } catch (error) {
        if ((error as Response)?.status) {
            return (error as Response).status;
        }
        throw error;
    }
};

const ssoRedirect = async (response: Response) => {
    const successResponse: PlacerResponseData<SsoSuccessDataResponse> = await response.json();
    const urlTarget = `${successResponse.data.idp_redirect_url}`;

    goToHref(urlTarget);
};

export const authSendSsoToken = async (token: SsoLandingPageParameters) =>
    await authAPI.sendSsoToken(token);
